<template>
  <div class="add-new-user">
    <h1 class="page-header color-1-100" v-if="step < 2">Invite new user to Clear Assured</h1>
    <div class="admin-breadcrumbs">
      <router-link class="dashboard background-1-20 color-2-100" to="/" v-if="step < 2">Go to Dashboard</router-link>
      <button class="add-users background-1-20 color-2-100"
              @click.prevent="inviteNewUsers()"
              v-if="(inviteType === 1 && step === 2) || (inviteType === 2 && currentStepImport === 3)">Invite new users</button>
      <router-link class="all-users" :to="{ name: getUserRole === 'gm' ? 'users' : 'ca-users' }">Back to all users list</router-link>
    </div>
    <div class="content-section content-section__bordered border-1-20 add-user-section" ref="content">
      <div>
        <div class="add-new-user-form">
          <h3 class="content-section-title color-1-100 background-1-100-before">
            <template v-if="(inviteType === 1 && step === 0) || (inviteType === 2 && currentStepImport === 0)">
              Step 1: invite new users
            </template>
            <template v-else-if="(inviteType === 2 && currentStepImport === 1)">
              Step 2: Sync csv columns
            </template>
            <template v-else-if="inviteType === 1 && step === 1">
              Step 2: complete user profiles
              <span class="hide-desktop">
                ({{ userInvites.length }} <template v-if="userInvites.length === 1">user</template><template v-else>users</template>)
              </span>
            </template>
            <template v-else-if="inviteType === 2 && currentStepImport === 2">
              Step 3: complete user profiles
              <span class="hide-desktop">
                ({{ userInvites.length }} <template v-if="userInvites.length === 1">user</template><template v-else>users</template>)
              </span>
            </template>
            <template v-else>
              Users status
            </template>
          </h3>
          <p class="content-section-description" v-if="(inviteType === 1 && step === 0) || (inviteType === 2 && currentStepImport === 0)">
            Add the email addresses of the people you want to invite to use Clear Assured in the Email box below,
            you can add up to 500 users. Select the user role that you want to assign to these users.
            You can amend the role on the next page if they are not all the same.
          </p>
          <div class="invite-users-methods"
               v-if="(inviteType === 1 && step === 0) || (inviteType === 2 && currentStepImport === 0)">
            <div class="form-group">
              <div class="form-control form-control__radio">
                <input id="invite-users-by-paste"
                       v-bind:checked="inviteType === 1"
                       v-on:change="changeInviteType(1)"
                       type="radio"
                       name="invite-type" />
                <label for="invite-users-by-paste" class="form-label color-2-63">Paste emails</label>
              </div>
              <div class="form-control form-control__radio">
                <input id="invite-users-by-csv"
                       v-bind:checked="inviteType === 2"
                       v-on:change="changeInviteType(2)"
                       type="radio"
                       name="invite-type"
                       class="form-control form-control__radio" />
                <label for="invite-users-by-csv" class="form-label color-2-63">Import CSV file</label>
              </div>
            </div>
          </div>
          <template v-if="step === 0 && inviteType === 1">
            <div class="form-group-ninth">
              <div class="form-group form-group-half invite-emails-container">
                <div class="form-element">
                  <label for="new-user-emails" class="form-label color-2-63">
                    Email addresses
                    <button
                      class="invite-emails-clear"
                      v-if="userInvites.length"
                      @click.prevent="clearAllEmails()">Clear all</button>
                  </label>
                  <div class="invite-emails-wrapper"
                       :class="[{ 'active': userInvites.length }]"
                       ref="emailsAddWrapper"
                       @click.prevent="$refs.inputEmails.focus()">
                    <div class="invite-emails-item"
                         :class="[{ 'error': !item.isValid }]"
                         @click.prevent="changeEmail($event, index)"
                         v-for="(item, index) in userInvites">
                      {{ item.email }}
                      <button @click.prevent="removeEmail(index, 0)"></button>
                    </div>
                    <textarea cols="20" rows="1"
                              class="invite-emails-input"
                              data-lpignore="true"
                              v-on:blur="createTags($event)"
                              v-on:paste="email.isPaste = true"
                              v-on:input="createTags($event, true)"
                              v-on:keydown="emailsKeyDown($event)"
                              v-model="email.input"
                              id="new-user-emails" ref="inputEmails"
                              style="white-space: nowrap; overflow: hidden;"></textarea>
                  </div>
                </div>
              </div>
              <div class="form-group form-group-half">
                <div class="form-element">
                  <label for="new-user-company-role" class="form-label color-2-63">User type</label>
                  <v-select class="form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked"
                            :searchable = false
                            v-model="defaultRole"
                            :options="getRolesForSelect"
                            data-lpignore="true"
                            id="new-user-company-role" />
                </div>
                <div class="form-element" v-if="(defaultRole === null || (defaultRole && defaultRole.slug !== 'gm')) && getUserRole === 'gm'">
                  <label for="new-user-company" class="form-label color-2-63">Company</label>
                  <v-select class="form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked"
                            :searchable = true
                            v-model="defaultCompany"
                            :options="getCompaniesForSelect"
                            data-lpignore="true"
                            id="new-user-company" />
                </div>
              </div>
            </div>
          </template>
          <template v-if="currentStepImport === 0 && inviteType === 2">
            <div class="invite-users-upload-info">
              Please <a href="/import-users-sample.csv" download>download our CSV sample</a>, fill in your data and upload it here.
            </div>
            <div class="invite-users-upload-file">
              <div class="choose-file-wrapper">
                <input type='file' v-on:change='convertFile($event)' id='fileInput'>
                <button class="choose-file">choose file</button>
              </div>
              <span class="file-name">{{ fileName }}</span>
              <button class="upload-file"
                      @click.prevent="nextStep(2)"
                      v-if="usersImported">upload CSV file</button>
            </div>
          </template>
          <template v-else-if="(inviteType === 1 && (step === 1 || step === 2)) || (inviteType === 2 && (currentStepImport === 2 || currentStepImport === 3))">
            <div class="invite-emails-list"
                 :class="[{ 'server-response': (inviteType === 1 && step === 2) || (inviteType === 2 && currentStepImport === 3), 'is-admin': getUserRole === 'gm' }, 'step-' + step]">
              <div class="loading" v-if="requestInProcess"></div>
              <div class="form-group"
                   :class="[{ 'error': (inviteType === 1 && step === 2 && response[item.id].code > 0) || (inviteType === 2 && currentStepImport === 3 && response[item.id].code > 0) }]"
                   v-for="(item, index) in userInvites">
                <input type="hidden" v-model="item.id = index"/>
                <div class="form-element status" v-if="(inviteType === 1 && step === 2) || (inviteType === 2 && currentStepImport === 3)">
                  <span :class="[{ 'error': response[item.id].code > 0}]"></span>
                </div>
                <div class="form-element email">
                  <label class="form-label color-2-63"
                         :for="'user-invite-email-' + index"
                         v-show="index === 0">Email</label>
                  <textarea class="form-control form-control__textarea"
                            :class="[{ 'error': !item.isValid, 'active': item.email }]"
                            v-on:input="changeValid(item, $event.target.value)"
                            data-lpignore="true"
                            data-gramm_editor="false"
                            :id="'user-invite-email-' + index">{{ item.email }}</textarea>
                </div>
                <div class="form-element role">
                  <label class="form-label color-2-63"
                         :for="'user-invite-type-' + index"
                         v-show="index === 0">User type</label>
                  <v-select class="form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked"
                            :class="[{ 'active': item.role, 'has-error': userHasError('role', item) }]"
                            :searchable = false
                            v-model="item.role"
                            v-bind:on-change="roleChanged(item)"
                            :options="getRolesForSelect"
                            data-lpignore="true"
                            name="User type"
                            :id="'user-invite-type-' + index" />
                </div>
                <div class="form-element company" v-if="getUserRole === 'gm'">
                  <label class="form-label color-2-63"
                         :for="'user-invite-company-' + index"
                         v-show="index === 0">Company</label>
                  <v-select class="form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked"
                            :disabled="item.role && item.role.slug === 'gm'"
                            :class="[{ 'active': item.company, 'is-blocked': item.role && item.role.slug === 'gm', 'has-error': userHasError('company', item) }]"
                            :searchable = true
                            v-model="item.company"
                            :options="getCompaniesForSelect"
                            data-lpignore="true"
                            :id="'user-invite-company-' + index" />
                </div>
                <div class="form-element title">
                  <label class="form-label color-2-63"
                         :for="'user-invite-title-' + index"
                         v-show="index === 0">Title</label>
                  <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                         :disabled="item.role && item.role.slug === 'gm'"
                         :class="[{ 'active': item.title, 'is-blocked': item.role && item.role.slug === 'gm' }]"
                         data-lpignore="true"
                         v-model="item.title"
                         :id="'user-invite-title-' + index">
                </div>
                <div class="form-element function">
                  <label class="form-label color-2-63"
                         :for="'user-invite-title-' + index"
                         v-show="index === 0">Function</label>
                  <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                         :disabled="item.role && item.role.slug === 'gm'"
                         :class="[{ 'active': item.function, 'is-blocked': item.role && item.role.slug === 'gm' }]"
                         data-lpignore="true"
                         v-model="item.function"
                         :id="'user-invite-function-' + index">
                </div>
                <div class="form-element firstname">
                  <label class="form-label color-2-63"
                         :for="'user-invite-first-name-' + index"
                         v-show="index === 0">First name</label>
                  <input type="text" class="form-control form-control__input"
                         :class="[{ 'active': item.firstName }]"
                         data-lpignore="true"
                         v-model="item.firstName"
                         :id="'user-invite-first-name-' + index">
                </div>
                <div class="form-element lastname">
                  <label class="form-label color-2-63"
                         :for="'user-invite-last-name-' + index"
                         v-show="index === 0">Last name</label>
                  <input type="text" class="form-control form-control__input"
                         :class="[{ 'active': item.lastName }]"
                         data-lpignore="true"
                         v-model="item.lastName"
                         :id="'user-invite-last-name-' + index">
                </div>
                <div class="form-element phone">
                  <label class="form-label color-2-63"
                         :for="'user-invite-phone-' + index"
                         v-show="index === 0">Phone</label>
                  <input type="text" class="form-control form-control__input"
                         :class="[{ 'active': item.phone }]"
                         data-lpignore="true"
                         v-model="item.phone"
                         :id="'user-invite-phone-' + index">
                </div>
                <div class="form-element remove" v-if="(inviteType === 1 && step === 1) || (inviteType === 2 && currentStepImport === 2)">
                  <a href="#"
                     class="invite-emails-remove"
                     @click.prevent="removeEmail(index, 1)"></a>
                </div>
                <div class="invite-emails-error"
                     :class="[{ 'step2': (inviteType === 1 && step === 2) || inviteType === 2 && currentStepImport === 3 }]"
                     v-if="!item.isValid || (step === 2 && response[item.id].code > 0) || (currentStepImport === 3 && response[item.id].code > 0) || userHasError('role', item) || userHasError('company', item)">
                  <template v-if="!item.isValid || (inviteType === 1 && step === 2) || (inviteType === 2 && currentStepImport === 3)">
                    <template v-if="(inviteType === 1 && step === 2) || (inviteType === 2 && currentStepImport === 3)">
                      <template v-if="response[item.id].code === 2">
                        We were unable to send an email to this address. Please make sure you typed it correctly.
                        If you need assistance, please send us an email at support.team@clearassured.co.uk.
                      </template>
                      <template v-else-if="response[item.id].code === 3">
                        This user was not invited - the email we sent was marked as spam by the receipient server and rejected.
                        Please make sure you typed it correctly. If you need assistance, please send us an email at support.team@clearassured.co.uk.
                      </template>
                      <template v-else-if="response[item.id].code === 4">
                        We couldn't send an invite - this user is already in our system.
                      </template>
                      <template v-else-if="response[item.id].code === 5">
                        We encountered an error processing your request - we couldn't associate this user with a company.
                        Please try again and if the problem persists, get in touch with the website developers.
                      </template>
                      <template v-else-if="response[item.id].code === 6">
                        We couldn't invite this user. The domain of the email address you used is not approved for your organization.
                      </template>
                      <template v-else-if="response[item.id].code === 7">
                        <template v-if="getUserRole === 'ca'">
                          Users limit exceeded - your plan supports up to {{ user.company.employee_limit }} active users.
                        </template>
                        <template v-else>
                          Users limit exceeded - {{ item.company.label }} plan supports up to {{ item.company.usersLimit }} active users.
                        </template>
                      </template>
                      <template v-else>
                        We encountered an error processing your request. Some mandatory fields are missing or are filled in wrong.
                        Please try again and if the problem persists, get in touch with the website developers.
                      </template>
                    </template>
                    <template v-else>
                      Wrong email format. Please use a valid email address (e.g. name@domain.tld).
                    </template>
                  </template>
                  <template v-if="userHasError('role', item)">
                    <p>User type is mandatory field</p>
                  </template>
                  <template v-if="userHasError('company', item)">
                    <p>Company is mandatory field</p>
                  </template>
                </div>
              </div>
              <div class="invite-emails-status" v-if="(inviteType === 1 && step === 2 && status) || (inviteType === 2 && currentStepImport === 3 && status)">
                <p class="success" v-if="status.success">
                  <template v-if="status.success === 1">
                    1 user was successfully invited. <span>Invitation link expires after 30 days.</span>
                  </template>
                  <template v-else>
                    {{ status.success }} users were successfully invited. <span>Invitation link expires after 30 days.</span>
                  </template>
                </p>
                <p class="error" v-if="status.error">
                  <template v-if="status.error === 1">
                    1 user was not invited.
                  </template>
                  <template v-else>
                    {{ status.error }} users were not invited.
                  </template>
                </p>
              </div>
            </div>
          </template>
          <template v-if="inviteType === 2 && currentStepImport === 1">
            <div class="invite-emails-list from-import">
              <div class="flex-block">
                <div class="form-element" v-for="col in csvData">
                  <v-select class="form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked"
                            :class="[{ 'valid': col.column.value !== 'skip' }]"
                            :searchable = false
                            :options="columns"
                            v-model="col.column"
                            placeholder="Skip this column"
                            data-lpignore="true" />
                  <div class="form-info email" v-for="(item, i) in col.items"
                       :hidden="ignoreFirstRow && i === 0">
                    {{ item }}
                  </div>
                </div>
              </div>
              <div class="invite-users-ignore-first">
                <div class="form-group">
                  <div class="form-element">
                    <input id="invite-users-ignore-first"
                           v-bind:checked="ignoreFirstRow"
                           @change="changeIgnoreFirst()"
                           type="checkbox"
                           class="form-control form-control__checkbox" />
                    <label for="invite-users-ignore-first" class="form-label color-2-63">Don't import first row</label>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="invite-emails-info hide-desktop"
           v-if="step === 1 || currentStepImport === 2">List contains {{ userInvites.length }}
        <template v-if="userInvites.length === 1">
          user.
        </template>
        <template v-else>
          users.
        </template>
      </div>
      <div class="clearfix"></div>
      <div class="add-new-user-control-panel"
           v-if="inviteType === 2 && currentStepImport === 1">
        <button type="button" v-on:click.prevent="nextStep(2)" class="submit-user">
          Next
        </button>
      </div>
      <div class="add-new-user-control-panel"
           v-if="(inviteType === 1 && (step === 0 || step === 1)) || (inviteType === 2 && currentStepImport === 2)">
        <button type="button" v-on:click.prevent="nextStep(3)" class="submit-user">
          <template v-if="inviteType === 1">
            Next
          </template>
          <template v-else>
            Send invitations
          </template>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '@/api'
  import { mapGetters, mapActions } from 'vuex'
  import AppSelect from '@/components/admin/common/Select'

  export default {
    name: 'add-user',
    data () {
      return {
        userInvites: [],
        defaultRole: null,
        defaultCompany: null,
        email: {
          input: '',
          active: false,
          isPaste: false
        },
        step: 0,
        disableAPI: false,
        requestInProcess: false,
        response: {},
        status: {},
        user: null,
        confOpened: null,
        confirmation: {
          action: '',
          isShown: false,
          articleId: null,
          i: null,
          style: {}
        },
        inviteType: 1,
        currentStepImport: 0,
        fileName: '',
        usersImported: false,
        ignoreFirstRow: true,
        columns: [
          {
            label: 'Skip this column',
            value: 'skip'
          },
          {
            label: 'Email address',
            value: 'email'
          },
          {
            label: 'Role',
            value: 'role'
          },
          {
            label: 'Company',
            value: 'company'
          }
        ],
        csvData: null
      }
    },
    computed: {
      ...mapGetters([
        'getCompaniesForSelect',
        'getUserRole',
        'getConfData',
        'getRolesForSelect'
      ])
    },
    methods: {
      ...mapActions([
        'getRoles',
        'clearConfAction',
        'initConfAction',
        'getCompanies',
        'setInformationMsg'
      ]),
      roleChanged (item) {
        if (item.role && item.role !== null && item.role.slug === 'gm') {
          item.company = null
        }
      },
      changeIgnoreFirst () {
        this.ignoreFirstRow = !this.ignoreFirstRow
      },
      goToPageSection (ref) {
        let element = this.$refs[ref]
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          })
          setTimeout(function () {
            element.focus()
          }, 0)
        }
      },
      nextStep (type) {
        if ((!this.userInvites.length && type === 1) || (!this.usersImported && type === 2)) {
          return
        }
        let self = this
        if (this.step === 0 && (type === 1 || type === 3)) {
          if (this.defaultCompany !== null) {
            for (let index in this.userInvites) {
              this.userInvites[index].company = this.defaultCompany
            }
          }
          if (this.defaultRole !== null) {
            for (let index in this.userInvites) {
              if (this.defaultRole.slug === 'gm') {
                this.userInvites[index].company = null
              }
              this.userInvites[index].role = this.defaultRole
            }
          }
          setTimeout(function () {
            self.autoHeight()
          }, 100)
          this.step += 1
        } else if ((this.step === 1 && (type === 1 || type === 3)) || (this.currentStepImport === 2 && type === 3)) {
          if (this.user && this.user.email_endings === '' && this.getUserRole === 'ca') {
            this.sendInvitations('noDomains')
          } else {
            this.sendInvitationsConfirmed()
          }
        } else if (this.currentStepImport === 0 && type === 2) {
          this.currentStepImport += 1
          this.goToPageSection('content')
        } else if (this.currentStepImport === 1 && type === 2) {
          let synchronised = this.csvData.some((item) => item.column && item.column.value === 'email')
          if (synchronised) {
            this.columns2rows()
            this.goToPageSection('content')
            setTimeout(function () {
              self.autoHeight()
            }, 100)
            return
          } else {
            alert('Please sync columns')
            return
          }
        }
      },
      columns2rows () {
        let reorderedData = []
        let emailColumn = this.csvData.find((item) => item.column !== undefined && item.column.value === 'email')
        let companyColumn = this.csvData.find((item) => item.column !== undefined && item.column.value === 'company')
        let roleColumn = this.csvData.find((item) => item.column !== undefined && item.column.value === 'role')

        reorderedData.push(emailColumn)

        if (roleColumn !== undefined) {
          reorderedData.push(roleColumn)
        } else {
          reorderedData.push({
            column: this.columns.find((item) => item.value === 'role'),
            columnIndex: 3,
            items: []
          })
        }

        if (this.getUserRole === 'gm') {
          if (companyColumn !== undefined) {
            reorderedData.push(companyColumn)
          } else {
            reorderedData.push({
              column: this.columns.find((item) => item.value === 'company'),
              columnIndex: 2,
              items: []
            })
          }
        }

        let w = reorderedData.length || 0
        let h = reorderedData[0].items instanceof Array ? reorderedData[0].items.length : 0

        if (h === 0 || w === 0) {
          return
        }

        let i
        let j
        let t = []

        for (i = 0; i < h; i++) {
          if (this.ignoreFirstRow && i === 0) {
            continue
          }
          t[i] = {
            id: i,
            email: '',
            role: null,
            title: '',
            function: '',
            firstName: '',
            lastName: '',
            phone: '',
            company: null,
            isValid: false
          }
          for (j = 0; j < w; j++) {
            let column = reorderedData[j] && reorderedData[j].column ? reorderedData[j].column.value : null
            if (column) {
              if (column === 'email') {
                t[i][column] = reorderedData[j].items[i]
                t[i].isValid = this.isValidEmail(reorderedData[j].items[i])
              } else if (column === 'company') {
                t[i][column] = this.getCompaniesForSelect.find(item => item.label === reorderedData[j].items[i]) || null
              } else if (column === 'role') {
                t[i][column] = this.getRolesForSelect.find(item => item.label === reorderedData[j].items[i].replace('\r', '')) || null
              }
            }
          }
        }
        this.userInvites = t.filter((row) => row)
        this.currentStepImport += 1
      },
      isValid (column, item) {
        if (column && column.value === 'email') {
          return this.maybeIsEmailColumn(item)
        } else if (column && column.value === 'role') {
          if (typeof item === 'object') {
            return !!item
          }
        } else if (column && column.value === 'company') {
          if (typeof item === 'object') {
            return !!item
          }
        } else {
          return true
        }
      },
      sendInvitations (conf) {
        let actionName
        if (conf === 'noDomains') {
          actionName = 'noAllowedEmailDomains'
        }
        this.confOpened = 'invite'
        this.initConfAction({
          actionName: actionName
        })
      },
      sendInvitationsConfirmed () {
        if (this.disableAPI) return
        this.disableAPI = true
        this.requestInProcess = true
        let hasErrors = false
        let self = this
        let body = []
        for (let index in this.userInvites) {
          let user = this.userInvites[index]
          let role = user.role ? user.role.slug : null
          let company = user.company
          if (!user.isValid) {
            hasErrors = true
            this.disableAPI = false
            this.requestInProcess = false
            return
          }
          if (role === null) {
            hasErrors = true
            this.disableAPI = false
            this.requestInProcess = false
            return
          }
          if (this.getUserRole === 'gm' && role !== 'gm' && company === null) {
            hasErrors = true
            this.disableAPI = false
            this.requestInProcess = false
            return
          }
          let newUser = {
            id: user.id,
            email: user.email,
            role: user.role ? user.role.value : null,
            title: user.title,
            function: user.function,
            firstName: user.firstName,
            lastName: user.lastName,
            phone: user.phone,
            company: null
          }
          if (user.company) {
            newUser.company = user.company ? user.company.value : null
          }
          body.push(newUser)
        }
        if (hasErrors) {
          this.disableAPI = false
          this.requestInProcess = false
          return
        }
        this.$http.post(api.URLS.inviteUsers, body, api.headersAuthSettings).then((res) => {
          this.disableAPI = false
          this.requestInProcess = false
          this.response = res.body.users
          this.status = res.body.count
          this.step += 1
          this.currentStepImport += 1
          setTimeout(function () {
            self.autoHeight()
          }, 100)
        }).catch((err) => {
          this.disableAPI = false
          this.requestInProcess = false
          console.log(err)
        })
      },
      getProfileData () {
        this.$http.put(api.URLS.profile, {}, api.headersAuthSettings).then((res) => {
          this.user = res.body
        })
      },
      changeInviteType (type) {
        this.inviteType = type
      },
      convertFile (e) {
        let input = e.target
        let reader = new FileReader()
        reader.onload = () => {
          this.fileName = input.files[0] ? input.files[0].name : ''
          var lines = reader.result.split('\n')

          var result = lines.map(function (line) {
            return line.split(',')
          })

          this.initCsvColumnSync(result)

          // let text = reader.result
          // this.$papa.parse(text, {
          //   complete: (results, file) => {
          //     this.initCsvColumnSync(results)
          //   }
          // })
        }
        reader.readAsText(input.files[0])
      },
      initCsvColumnSync (results) {
        let data = results

        let columns = []

        let cleanData = data.filter((row) => {
          return row.some((item) => item !== '')
        })

        cleanData.forEach((row, i) => {
          if (i === 0) {
            const firstRowHasEmail = row.some((item) => this.maybeIsEmailColumn(item))
            if (firstRowHasEmail) {
              this.ignoreFirstRow = false
            }
          }
          row.forEach((item, index) => {
            const thisColumn = columns.findIndex((find) => find.columnIndex === index)
            if (thisColumn > -1) {
              columns[thisColumn].items.push(item)
              columns[thisColumn].column = columns[thisColumn].column === undefined || columns[thisColumn].column.value === 'skip' ? this.identifyColumn(item) : columns[thisColumn].column
              columns[thisColumn].synchronised = this.isColumnSynchronised(columns[thisColumn])
            } else {
              columns.push({
                columnIndex: index,
                column: this.identifyColumn(item) || undefined,
                synchronised: false,
                items: [
                  item
                ]
              })
            }
          })
        })
        this.csvData = columns
        this.usersImported = true
      },
      identifyColumn (item) {
        if (this.maybeIsEmailColumn(item)) {
          return this.columns.find((column) => column.value === 'email')
        }
        const nonEmailColumns = this.columns.filter((column) => column.value !== 'email')
        let existingColumn
        nonEmailColumns.forEach((column) => {
          if (item.indexOf(column.label) > -1) {
            existingColumn = column
          }
        })
        if (existingColumn !== undefined) {
          return existingColumn
        }
        return this.columns.find((column) => column.value === 'skip')
      },
      isColumnSynchronised (item) {
        if (item.synchronised) {
          return
        }
        return item.column !== undefined
      },
      synchroniseColumn (e, col) {
        col.column = e.option
        col.synchronised = true
      },
      maybeIsEmailColumn (text) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return re.test(text)
      },
      createTags (el, wait) {
        if (wait && !this.email.isPaste) {
          return
        }
        let self = this
        let emails = this.email.input.split(/(?:,| |>|<|"|'|;)+/)
        for (let index in emails) {
          if (emails[index] !== '') {
            let company = this.defaultCompany
            this.userInvites.push({
              id: index,
              email: emails[index],
              role: this.defaultRole,
              title: null,
              function: null,
              firstName: null,
              lastName: null,
              phone: null,
              company: company,
              isValid: this.isValidEmail(emails[index]),
              code: 0
            })
          }
        }
        setTimeout(function () {
          self.email.isPaste = false
          self.autoWidth(el)
          el.value = ''
          self.email.input = ''
          if (self.$refs.emailsAddWrapper) {
            self.$refs.emailsAddWrapper.scrollTop = self.$refs.emailsAddWrapper.scrollHeight
          }
        }, 10)
      },
      changeEmail (evt, index) {
        this.email.input = evt.target.innerText
        this.userInvites.splice(index, 1)
        let el = this.$refs.inputEmails
        setTimeout(function () {
          el.style = 'width: 10px'
          el.style = 'width:' + (el.scrollWidth + 10) + 'px'
        }, 10)
      },
      changeValid (item, value) {
        item.isValid = this.isValidEmail(value)
        item.email = value
        this.autoHeight()
      },
      removeEmail (index, pos) {
        this.userInvites.splice(index, pos)
        if (this.step === 1 && !this.userInvites.length) {
          this.step = 0
        }
      },
      clearAllEmails () {
        this.userInvites = []
      },
      emailsKeyDown (evt) {
        if ([13, 27, 32, 59, 188, 222].indexOf(evt.keyCode) !== -1) {
          this.createTags(evt)
        }
        this.autoWidth(evt)
      },
      goToUsersList () {
        let usersPage = this.getUserRole === 'gm' ? 'users' : 'ca-users'
        let props = this.$router.resolve({
          name: usersPage
        })
        this.$router.push(props.href)
      },
      inviteNewUsers () {
        this.userInvites = []
        this.defaultRole = null
        this.defaultCompany = null
        this.email = {
          input: '',
          active: false,
          isPaste: false
        }
        this.inviteType = 1
        this.step = 0
        this.currentStepImport = 0
        this.response = {}
        this.status = {}
      },
      autoWidth (el) {
        let target = this.getTarget(el)
        setTimeout(function () {
          if (target) {
            target.style.width = '10px'
            target.style.width = (target.scrollWidth + 15) + 'px'
          }
        }, 0)
      },
      autoHeight () {
        let textAreas = document.getElementsByTagName('textarea')
        for (let i = 0; i < textAreas.length; i++) {
          let item = textAreas[i]
          if (item) {
            setTimeout(function () {
              item.style.height = '40px;'
              item.style.height = (item.scrollHeight + 4) + 'px'
            }, 0)
          }
        }
      },
      getTarget (e) {
        let evn = e || window.event
        return evn.srcElement || e.currentTarget
      },
      isValidEmail (email) {
        let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return re.test(email)
      },
      userHasError (type, item) {
        if (type === 'role') {
          return item.role === null
        }
        if (type === 'company') {
          if (this.getUserRole === 'ca' || this.getUserRole === 'ta' || this.getUserRole === 'la') {
            return false
          }
          return (item.company === null && (item.role !== null && item.role.slug !== 'gm')) || (item.company === null && item.role === null)
        }
      }
    },
    created () {
      document.title = 'Invite users | Clear Assured'
      if (window.ga) {
        window.ga('set', 'contentGroup1', 'ADMINISTRATION_AREA')
        window.ga('send', 'pageview', {
          'page': location.pathname,
          'location': location.href,
          'title': document.title
        })
      }
    },
    mounted () {
      this.getRoles()
      this.getCompanies()
      this.getProfileData()
    },
    components: {
      AppSelect
    },
    watch: {
      'getConfData.actionConfirmed' (value) {
        if (value) {
          if (this.confOpened === 'invite') this.sendInvitationsConfirmed()
          this.clearConfAction()
        }
      }
    }
  }
</script>

<style src='@/assets/scss/components/add-user.scss' lang='scss' scoped />



// WEBPACK FOOTER //
// AddUser.vue?498de16f